module.exports = __webpack_public_path__ + "static/stores-payment-29ebdf162a6c0b1d7b73e1d719600dcc.png";